import React from 'react';

import type { PopoverProps } from '@mui/material';
import { MenuList, Paper, Popover } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import type { ColorSelectFunction } from './ColorSelectComponent';
import { ColorSelectMenuColumn } from './ColorSelectMenuColumn';
import { TransparentOption } from './TransparentOption';

const useStyles = makeStyles()(theme => ({
  menu: {
    padding: theme.spacing(1, 1, 0.5),
  },
  menuList: {
    display: 'flex',
  },
  popper: {
    // This zIndex is to make sure that the Popper stays higher than the AppBar.
    zIndex: theme.zIndex.modal,
  },
}));

interface ColorSelectMenuProps {
  anchorEl: PopoverProps['anchorEl'];
  colorColumns: string[][];
  handleClose: () => void;
  hasTransparentOption: boolean;
  open: boolean;
  selectColor: ColorSelectFunction;
  selectedColor: string | null;
}

export function ColorSelectMenu({
  anchorEl,
  colorColumns,
  handleClose,
  hasTransparentOption,
  open,
  selectColor,
  selectedColor,
}: ColorSelectMenuProps): JSX.Element | null {
  const { classes } = useStyles();

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      className={classes.popper}
      open={open}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      onClose={handleClose}
    >
      <Paper className={classes.menu} elevation={3}>
        {/* MenuList provides the MenuListContext that v9 MenuItem requires. */}
        <MenuList>
          {hasTransparentOption && <TransparentOption selectColor={selectColor} />}
          <div className={classes.menuList}>
            {colorColumns.map((colorPalette: string[]) => {
              return (
                <ColorSelectMenuColumn
                  key={colorPalette[0]}
                  colors={colorPalette}
                  selectColor={selectColor}
                  selectedColor={selectedColor}
                />
              );
            })}
          </div>
        </MenuList>
      </Paper>
    </Popover>
  );
}
